import { folderStore } from '../store/store';
import Folder from '../store/schema/Folder';
import { select } from 'satcheljs/lib/legacy';
import isFolderOrSubFolderOfDistinguishedFolder, {
    FolderTableState,
    isUnderDistinguishedFolder,
} from './isFolderOrSubFolderOfDistinguishedFolder';

export default select<FolderTableState>({
    folderTable: () => folderStore.folderTable,
})(function isFolderUnderMsg(folder: Folder, state?: FolderTableState): boolean {
    return isUnderDistinguishedFolder(folder, 'msgfolderroot', state);
});

/**
 * @param folderId - Id of folder for which we are checking
 * @returns boolean - true if folder is primary root or a subfolder of primary root
 */
export function isFolderOrSubFolderOfMsgRoot(folderId: string): boolean {
    return isFolderOrSubFolderOfDistinguishedFolder(
        folderStore.folderTable.get(folderId),
        'msgfolderroot'
    );
}
